import { Brick, registerBrick} from 'olympe';

/**
 * This brick convert a User Defe
 */
export default class UserDefaultsToObject extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {UserDefaults} userDefaults
     * @param {string} userId
     * @param {function({})} setObject
     */
    update($, [userDefaults, userId], [setObject]) {
        setObject({
            username: userId,
            purchase_organization: userDefaults.getPurchOrg(),
            account_type: userDefaults.getAccountType(),
            company_code: userDefaults.getCompCode(),
            purchasing_group: userDefaults.getPurchGroup(),
            account_number: userDefaults.getAccountNumber(),
            plant: userDefaults.getPlant(),
            storage_location: userDefaults.getStorageLocation(),
            gl_number: userDefaults.getGLAccount(),
            tax_code: userDefaults.getTaxCode(),
            currency: userDefaults.getCurrency(),
            wbs_project: userDefaults.getWBSProject(),
            cost_center: userDefaults.getCostCenter(),
            profit_center: userDefaults.getProfitCenter(),
            delivery_address: userDefaults.getDeliveryAddress(),
            spender: userDefaults.getSpender(),
            requester: userDefaults.getRequester(),
            hide_price: userDefaults.getHidePrice(),
        });
    }
}

registerBrick('0190fdc7bf02142f58c9', UserDefaultsToObject);
